<template>
  <section class="vehicle-page-lease-info">
    <div class="vehicle-page-lease-info__container">
      <div class="vehicle-page-lease-info__content">
        <div class="vehicle-page-lease-info__title-wrap">
          <p class="vehicle-page-lease-info__eyebrow">{{ eyebrow }}</p>
          <h2 class="vehicle-page-lease-info__title">{{ title }}</h2>
        </div>
        <p class="vehicle-page-lease-info__body">{{ description }}</p>
        <div class="vehicle-page-lease-info__actions">
          <CalculatorButton :label="ctaLabel" color="primary" rounded iconDirection="right" hasChevronIcon @click="$emit('enquire-now')" />
        </div>
      </div>
      <div class="vehicle-page-lease-info__image-wrap">
        <QImg :src="imageUrl" class="vehicle-page-lease-info__image" no-spinner />
      </div>
    </div>
  </section>
</template>

<script>
import { QImg } from 'quasar';
import CalculatorButton from '../CalculatorButton.vue';

export default {
  name: 'VehiclePageLeaseInfo',
  components: {
    QImg,
    CalculatorButton
  },
  props: {
    eyebrow: {
      type: String,
      default: 'BUSINESS LEASE'
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    ctaLabel: {
      type: String,
      default: 'Enquire now'
    },
    imageUrl: {
      type: String,
      default: ''
    }
  }
};
</script>
